import { IApplicationState } from '../../types/redux';
import { ITag } from '../../types/tag';

export function getAvailableTags(state: IApplicationState): ITag[] {
  return state.filters.tags;
}
